import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
import { useApiCall } from "../../../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../../../component/popup/modal-layout";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
} from "../../../../../../component/form/form-layout";
import XCloseIcon from "../../../../../../component/icons/x-close";
import Tooltip from "../../../../../../component/ui/tooltip";
import { GlobalContext } from "../../../../../../context/Context";
import { Trash2 } from "lucide-react";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddBrief = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  projectkey = "",
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  const AddField = () => {
    const newFields = [
      ...formik.values.extra_meta,
      { meta_key: "", meta_value: "" },
    ];
    formik.setFieldValue("extra_meta", newFields);
  };

  const DeleteField = (index) => {
    const newFields = formik.values.extra_meta.filter((_, i) => i !== index);
    formik.setFieldValue("extra_meta", newFields);
  };

  const validationSchema = yup.object({
    extra_meta: yup
      .array()
      .of(
        yup.object({
          meta_key: yup.string().required("Question is required"),
          meta_value: yup.string().required("Answer is required"),
        }),
      )
      .min(1, "At least 1 brief with question and answer is required"),
  });

  const formik = useFormik({
    initialValues: {
      extra_meta: [{ meta_key: "", meta_value: "" }],
    },
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      let data = {
        project_key: projectkey,
        questions: values?.extra_meta.map((item) => ({
          question: item.meta_key,
          answer: item.meta_value,
        })),
      };

      console.log("data", data);

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: `project/add-project-brief`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong",
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>Add Brief</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} text-xl flex shrink-0 cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  <FeildWraper width="100%">
                    {/* Form-level error */}
                    {typeof formik.errors.extra_meta === "string" && (
                      <div className="text-red-500 text-sm">
                        {formik.errors.extra_meta}
                      </div>
                    )}
                    {formik?.values?.extra_meta.map((field, index) => (
                      // <div className={`w-full flex gap-3`} key={index}>
                      //   {/* key */}

                      //   <input
                      //     type="text"
                      //     name={`extra_meta[${index}].meta_key`}
                      //     value={formik.values.extra_meta[index].meta_key}
                      //     onChange={formik.handleChange}
                      //     placeholder="key"
                      //   />

                      //   {/* value */}

                      //   <input
                      //     type="text"
                      //     name={`extra_meta[${index}].meta_value`}
                      //     value={formik.values.extra_meta[index].meta_value}
                      //     onChange={formik.handleChange}
                      //     placeholder="value"
                      //   />

                      //   <Tooltip
                      //     key={`${index}-asideBottomItems`}
                      //     className={`${Style.Tooltip}`}
                      //     boxClassName={Style.TooltipBox}
                      //     content="Delete Field"
                      //     position={"bottom center"}
                      //   >
                      //     <div
                      //       onClick={() => DeleteField(index)}
                      //       className="p-3 text-red-600"
                      //     >
                      //       <Trash2 size={18} />
                      //     </div>
                      //   </Tooltip>
                      // </div>
                      <div className={`w-full flex gap-3`} key={index}>
                        <div className="flex flex-col w-full">
                          <input
                            type="text"
                            name={`extra_meta[${index}].meta_key`}
                            value={field.meta_key}
                            onChange={formik.handleChange}
                            placeholder="Question"
                            className="border px-2 py-1 rounded"
                          />
                          {formik.errors.extra_meta &&
                            formik.errors.extra_meta[index]?.meta_key && (
                              <div className="text-red-500 text-sm">
                                {formik.errors.extra_meta[index].meta_key}
                              </div>
                            )}
                        </div>

                        <div className="flex flex-col w-full">
                          <input
                            type="text"
                            name={`extra_meta[${index}].meta_value`}
                            value={field.meta_value}
                            onChange={formik.handleChange}
                            placeholder="Answer"
                            className="border px-2 py-1 rounded"
                          />
                          {formik.errors.extra_meta &&
                            formik.errors.extra_meta[index]?.meta_value && (
                              <div className="text-red-500 text-sm">
                                {formik.errors.extra_meta[index].meta_value}
                              </div>
                            )}
                        </div>

                        <Tooltip
                          key={`${index}-asideBottomItems`}
                          content="Delete Field"
                          position={"bottom center"}
                        >
                          <div
                            onClick={() => DeleteField(index)}
                            className="p-3 text-red-600 cursor-pointer"
                          >
                            <Trash2 size={18} />
                          </div>
                        </Tooltip>
                      </div>
                    ))}

                    <button
                      type="button"
                      onClick={AddField}
                      className="flex flex-start text-blue-700 font-medium   w-full p-2 text-[16px]"
                    >
                      + Add Field
                    </button>
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button
            type="submit"
            className={`${Style.dcmb__submit} disabled:!opacity-70 disabled:!cursor-not-allowed`}
          >
            Apply
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddBrief;
